// script for step1
// document.addEventListener("DOMContentLoaded", function () {
//   // Part 1: Handling mlv_step2_section display based on MLVLabel click
//   const allSections = document.querySelectorAll('.mlv_step2_section');
//   if (allSections.length > 0) {
//     allSections.forEach((section, index) => {
//       section.style.display = index === 0 ? 'block' : 'none'; // Show first, hide others
//     });
//   }

//   const labels = document.querySelectorAll('.MLVlabel');
  
//   // Scroll to an element with an offset
//   function scrollToElement(element) {
//     debugger;
//     if (element) {
//       const topOffset = element.getBoundingClientRect().top + window.scrollY - 100; // Adjust offset if needed
//       window.scrollTo({ top: topOffset, behavior: "smooth" });
//     }
//   }

//   // Handle label click event
//   labels.forEach(label => {
//     label.addEventListener('click', function () {
//       // For MLVLabel click, show the corresponding mlv_step2_section
//       if (label.classList.contains('MLVlabel')) {
//         const productId = label.getAttribute('data-product-id');

//         // Hide all sections
//         allSections.forEach(section => {
//           section.style.display = 'none';
//         });

//         // Find the corresponding section and display it
//         const matchingSection = document.querySelector(`.mlv_step2_section[data-product-id="${productId}"]`);
//         if (matchingSection) {
//           matchingSection.style.display = 'block';
//           // matchingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
//         }
//       }

//       // For mlv_plans_label click, manage selected state and scroll to modem-main
//       if (label.classList.contains('mlv_plans_label')) {
//         const planLabels = document.querySelectorAll(".mlv_plans_label");

//         // Remove 'selected' and 'mlv_variant' classes from all labels
//         planLabels.forEach(l => l.classList.remove("selected", "mlv_variant"));

//         // Add 'selected' and 'mlv_variant' classes to the clicked label
//         label.classList.add("selected", "mlv_variant");

//         // Scroll to the specified element (first .modem-main element)
//         const firstModemMain = document.querySelector(".main_modem");
//         scrollToElement(firstModemMain);
//       }
//     });
//   });
// });


document.addEventListener("DOMContentLoaded", function () {
  // Part 1: Handling mlv_step2_section display based on MLVLabel click
  const allSections = document.querySelectorAll('.mlv_step2_section');
  if (allSections.length > 0) {
    allSections.forEach((section, index) => {
      section.style.display = index === 0 ? 'block' : 'none'; // Show first, hide others
    });
  }

  const labels = document.querySelectorAll('.MLVlabel');
  
  // Scroll to an element with an offset
  function scrollToElement(element) {
    if (element) {
      const topOffset = element.getBoundingClientRect().top + window.scrollY - 100; // Adjust offset if needed
      window.scrollTo({ top: topOffset, behavior: "smooth" });
    }
  }

  // Handle label click event
  labels.forEach(label => {
    label.addEventListener('click', function () {
      // For MLVLabel click, show the corresponding mlv_step2_section and scroll to .main_modem
      if (label.classList.contains('MLVlabel')) {
        const productId = label.getAttribute('data-product-id');

        // Hide all sections
        allSections.forEach(section => {
          section.style.display = 'none';
        });

        // Find the corresponding section and display it
        const matchingSection = document.querySelector(`.mlv_step2_section[data-product-id="${productId}"]`);
        if (matchingSection) {
          matchingSection.style.display = 'block';
          // Scroll to .main_modem after new section is displayed
          debugger;
          // const firstModemMain = document.querySelector(".main_modem:visible");
          const firstModemMain = Array.from(document.querySelectorAll('.mlv_step2_section')).find(section => {
          return section.offsetHeight > 0 && section.offsetWidth > 0;
        });
          if (firstModemMain) {
            scrollToElement(firstModemMain);
          } else {
            console.error('No .main_modem element found to scroll to.');
          }
        }
      }

      // For mlv_plans_label click, manage selected state and scroll to modem-main
      if (label.classList.contains('mlv_plans_label')) {
        const planLabels = document.querySelectorAll(".mlv_plans_label");

        // Remove 'selected' and 'mlv_variant' classes from all labels
        planLabels.forEach(l => l.classList.remove("selected", "mlv_variant"));

        // Add 'selected' and 'mlv_variant' classes to the clicked label
        label.classList.add("selected", "mlv_variant");

        // Scroll to the specified element (first .main_modem element)
        debugger;
        const firstModemMain = Array.from(document.querySelectorAll('.mlv_step2_section')).find(section => {
          return section.offsetHeight > 0 && section.offsetWidth > 0;
        });
        if (firstModemMain) {
          scrollToElement(firstModemMain);
        } else {
          console.error('No .main_modem element found to scroll to.');
        }
      }
    });
  });
});





// script for step2
document.addEventListener("DOMContentLoaded", function () {
  const modemLabels = document.querySelectorAll(".modem-main");
  const planLabels = document.querySelectorAll(".mlv_plans_label"); // Get all plan labels
  const mlv_step3_section = document.querySelector(".mlv_step3_section");

  function scrollToElement(element) {
    if (element) {
      const topOffset = element.getBoundingClientRect().top + window.scrollY - 100; // Adjust offset if needed
      window.scrollTo({ top: topOffset, behavior: "smooth" });
    }
  }

  function isPlanSelected() {
    return [...planLabels].some(label => label.classList.contains("selected"));
  }

  function getFirstElement(selector) {
    return document.querySelector(selector);
  }

  modemLabels.forEach(label => {
    label.addEventListener("click", function () {
      if (isPlanSelected()) {
        // Remove 'selected' and 'mlv_variant' from all modem items
        modemLabels.forEach(l => l.classList.remove("selected", "mlv_variant"));

        // Add 'selected' and 'mlv_variant' to clicked modem item
        mlv_step3_section.style.display = 'flex';
        this.classList.add("selected", "mlv_variant");

        // Scroll to .steps-item
        scrollToElement(getFirstElement(".steps-item"));
      } else {
        // Scroll to .mlv_plans_label instead
        scrollToElement(getFirstElement(".mlv_plans_label"));
      }
    });
  });
});



// Wait for the document to be fully loaded
// document.addEventListener("DOMContentLoaded", function() {
//   // Initially, display the first mlv_step2_section and hide others
//   const allSections = document.querySelectorAll('.mlv_step2_section');
//   if (allSections.length > 0) {
//     allSections.forEach((section, index) => {
//       section.style.display = index === 0 ? 'block' : 'none'; // Show first, hide others
//     });
//   }

//   // Add event listener to each MLVLabel
//   const labels = document.querySelectorAll('.MLVlabel');
//   labels.forEach(label => {
//     label.addEventListener('click', function() {
//       const productId = label.getAttribute('data-product-id');
      
//       // Hide all sections
//       allSections.forEach(section => {
//         section.style.display = 'none';
//       });

//       // Find the corresponding section and display it
//       const matchingSection = document.querySelector(`.mlv_step2_section[data-product-id="${productId}"]`);
//       if (matchingSection) {
//         matchingSection.style.display = 'block'; // Display the matching section
//       }
//     });
//   });
// });